import type { FaireProductEntity } from "../../entity_types/product";

export const p_8nk7eetr3n: FaireProductEntity = {
  token: "p_8nk7eetr3n",
  type: "product",
  name: "Mixed-Flavor Case -  6 cans of each of our four core flavors",
  brandToken: "b_m7dq6epgxj",
  brandName: "Figment Kombucha",
  imageUrl:
    "https://cdn.faire.com/fastly/157635f2432939492d2ac8550a2e6639d54d6c18fa8548a6bf48fd70b9908477.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a3c0d7c68a9b3e6b71786abda878a1dc2d0e47b902dfd0a5ce2af611f3a90a35.png",
    "https://cdn.faire.com/fastly/24b8894b5fe2644f729f118d96306312965f42799c038c686d66f20b294d6432.jpeg",
    "https://cdn.faire.com/fastly/99651a6dd94493dc09d4f1f59bd9ab42270273f5fbc947de3e698ada5a241725.jpeg",
    "https://cdn.faire.com/fastly/e37456523dadc134a37cf84fd4f07fef52b5770d1c32579cf181e004645e402f.jpeg",
    "https://cdn.faire.com/fastly/cc379082d08ad219f58b334920191232d738afbdcaad556f91382a313d0f4bd4.jpeg",
    "https://cdn.faire.com/fastly/4ba09eaa8d2763d261269ee2a5d562dcd5b400118c017330ef82ad72fbe75449.png",
    "https://cdn.faire.com/fastly/783146a1ec54bc86cd97956e256ce50ef5f6b550531fc0df056db7f36e5f0585.png",
    "https://cdn.faire.com/fastly/5917cec68fb382c0666b025824a18079e91e473ebaca97006c1d61a0ef51479b.png",
    "https://cdn.faire.com/fastly/87972b46e793293aba9188d0f18b03e8b0610be8563f92e0dfd16a8e958247cb.png",
  ],
  priceDollars: 4.16,
  description:
    "Don't have room in cold storage for several cases of cans? This mixed case allows you to sell multiple flavors of Figment Kombucha without committing to multiple cases. Contains 6 cans of each of our core flavors: Blueberry/Lavender, Mango/Ginger, Strawberry/Lemon, and Orange Blossom.\n\nAlways live cultured, probiotic, non-alcoholic (all live-cultured fermented foods may contain trace amounts of alcohol), low sugar, gluten-free and vegan. Keep refrigerated at all times.",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:53.928Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
